/** Operations report body: skeleton while pending, data once the payload arrives. */

export function opsReportBodyMode({ isPending, hasData }) {
  if (hasData) return 'data'
  if (isPending) return 'skeleton'
  return 'idle'
}
